import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useTranslation } from 'react-i18next';
import { hasThankYouPageMap } from '../../integrationStatusUtils';
import { SettingsWrapper } from '../../../settings-wrapper/SettingsWrapper';

export const ThankYouPageMapIntegration = ({
    thankYouPageMapIntegration,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: ThankYouPageMapIntegrationProps) => {
    const { t } = useTranslation();

    const hasThankYouPageMapIntegration = hasThankYouPageMap(thankYouPageMapIntegration);

    const handleAddStoreAppBlock = () => {
        open(`shopify://admin/settings/checkout/editor?page=thank-you&context=apps`, '_blank');
        handleClickAddStoreAppBlock?.();
    };

    return (
        <SettingsWrapper
            title={t('DASHBOARD.APP_EXTENSIONS.THANK_YOU_PAGE_MAP_INTEGRATION.TITLE')}
            badge={
                <s-badge tone={hasThankYouPageMapIntegration ? 'success' : undefined}>
                    {hasThankYouPageMapIntegration
                        ? t('DASHBOARD.APP_EXTENSIONS.ACTIVE')
                        : t('DASHBOARD.APP_EXTENSIONS.INACTIVE')}
                </s-badge>
            }
            description={
                hasThankYouPageMapIntegration
                    ? t('DASHBOARD.APP_EXTENSIONS.THANK_YOU_PAGE_MAP_INTEGRATION.ACTIVE')
                    : t('DASHBOARD.APP_EXTENSIONS.THANK_YOU_PAGE_MAP_INTEGRATION.INACTIVE')
            }
            actions={
                <s-button variant="secondary" onClick={handleAddStoreAppBlock}>
                    {t('DASHBOARD.APP_EXTENSIONS.THANK_YOU_PAGE_MAP_INTEGRATION.ACTIONS.ADD_THANK_YOU_PAGE_MAP')}
                </s-button>
            }
            isLoading={isLoading}
            condensed={condensed}
        />
    );
};

interface ThankYouPageMapIntegrationProps {
    thankYouPageMapIntegration: ExtensionInfo;
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
